import { render, staticRenderFns } from "./dashboard-filters.vue?vue&type=template&id=0066c42b"
import script from "./dashboard-filters.vue?vue&type=script&lang=js"
export * from "./dashboard-filters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports